const SITE_URL = (typeof __VITE_SITE_URL__ !== 'undefined' ? __VITE_SITE_URL__ : 'https://yoybuy.skin') as string;

interface SchemaOrgProps {
  type: 'WebSite' | 'Organization' | 'Article';
  data: Record<string, unknown>;
}

function buildJsonLd(type: SchemaOrgProps['type'], data: Record<string, unknown>): Record<string, unknown> {
  const base = {
    '@context': 'https://schema.org',
    '@type': type,
    ...data,
  };
  return base;
}

export function WebsiteSchema() {
  const json = buildJsonLd('WebSite', {
    name: 'Yoybuy Sheet',
    url: SITE_URL,
    description: 'Профессиональная система таблиц для сравнения китайских shopping-агентов. Сравнивайте Yoybuy, Kakobuy и Superbuy в одной таблице.',
    inLanguage: 'ru-RU',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${SITE_URL}/search?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  });

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(json) }}
    />
  );
}

export function OrganizationSchema() {
  const json = buildJsonLd('Organization', {
    name: 'Yoybuy Sheet',
    url: SITE_URL,
    logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/67a09e300463e31c534fce7fbe7473f7.jpeg',
    description: 'Независимый инструмент сравнения shopping-агентов Китая. Сравнивайте цены, комиссии и доставку Yoybuy, Kakobuy и Superbuy.',
    sameAs: [
      'https://kaspreadsheet.com',
    ],
  });

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(json) }}
    />
  );
}

interface ArticleSchemaProps {
  headline: string;
  description: string;
  datePublished: string;
  dateModified: string;
  url: string;
  image?: string;
}

export function ArticleSchema({ headline, description, datePublished, dateModified, url, image }: ArticleSchemaProps) {
  const json = buildJsonLd('Article', {
    headline,
    description,
    datePublished,
    dateModified,
    url,
    ...(image ? { image } : {}),
    author: {
      '@type': 'Organization',
      name: 'Yoybuy Sheet',
      url: SITE_URL,
    },
    publisher: {
      '@type': 'Organization',
      name: 'Yoybuy Sheet',
      logo: {
        '@type': 'ImageObject',
        url: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/67a09e300463e31c534fce7fbe7473f7.jpeg',
      },
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': url,
    },
  });

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(json) }}
    />
  );
}

declare const __VITE_SITE_URL__: string;